import React from 'react';
import PropTypes from 'prop-types';
import { hasChildren } from '../../helpers';

const SubMenu = ({ children, modifier }) => {
  const hasValidChildren = hasChildren(children);
  if (!hasValidChildren) return null;
  return <ul className={modifier}>{children}</ul>;
};

SubMenu.propTypes = {
  modifier: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

SubMenu.defaultProps = {
  modifier: '',
  children: null
};

export default SubMenu;
